import React, { useEffect } from "react";
import Modal from "react-modal";
import "./MobileFilters.css";
import Slider from "@mui/material/Slider";
import { useState } from "react";

const customStyles = {
  content: {
    top: "15%",
    left: "0%",
    right: "0%",
    bottom: "10%",
    width: "100%",
    height: "100vh",
    borderRadius: "3rem",
  },
};

const marks = [
  {
    value: 0,
    label: "0.00 KM",
  },
  {
    value: 50,
    label: "50 KM",
  },
  {
    value: 100,
    label: "Maximum",
  },
];

const priceFilters = [
  { label: "Free", value: "-0" },
  { label: "0 - 200", value: "0-200" },
  { label: "200 - 500", value: "200-500" },
  { label: "500+", value: "500-" },
];

const sortFilters = [
  { label: "Fees - Low to High", value: "fees" },
  { label: "Fees - High to Low", value: "-fees" },
  { label: "Years of Experience", value: "exp" },
  { label: "Recommendation", value: "recommendation" },
];

const specialityFilters = [{"label":"Anaesthesiologists","value":"Anaesthesiologists"},{"label":"Allergists/Immunologists","value":"Allergists/Immunologists"},{"label":"Cardiologists","value":"Cardiologists"},{"label":"Colon and Rectal Surgeons","value":"Colon and Rectal Surgeons"},{"label":"Critical Care Medicine Specialists","value":"Critical Care Medicine Specialists"},{"label":"Dermatologists","value":"Dermatologists"},{"label":"Endocrinologists","value":"Endocrinologists"},{"label":"Emergency Medicine Specialists","value":"Emergency Medicine Specialists"},{"label":"General Physicians","value":"General Physicians"},{"label":"Gastroenterologists","value":"Gastroenterologists"},{"label":"Geriatric Medicine Specialists","value":"Geriatric Medicine Specialists"},{"label":"Haematologists","value":"Haematologists"},{"label":"Hospice and Palliative Medicine Specialists","value":"Hospice and Palliative Medicine Specialists"},{"label":"Infectious Disease Specialists","value":"Infectious Disease Specialists"},{"label":"Internists","value":"Internists"},{"label":"Medical Geneticists","value":"Medical Geneticists"},{"label":"Nephrologists","value":"Nephrologists"},{"label":"Neurologists","value":"Neurologists"},{"label":"Obstetricians and Gynaecologists","value":"Obstetricians and Gynaecologists"},{"label":"Oncologists","value":"Oncologists"},{"label":"Ophthalmologists","value":"Ophthalmologists"},{"label":"Osteopaths","value":"Osteopaths"},{"label":"Otolaryngologists","value":"Otolaryngologists"},{"label":"Pathologists","value":"Pathologists"},{"label":"Paediatricians","value":"Paediatricians"},{"label":"Physiatrists","value":"Physiatrists"},{"label":"Plastic Surgeons","value":"Plastic Surgeons"},{"label":"Podiatrists","value":"Podiatrists"},{"label":"Preventive Medicine Specialists","value":"Preventive Medicine Specialists"},{"label":"Psychiatrists","value":"Psychiatrists"},{"label":"Pulmonologists","value":"Pulmonologists"},{"label":"Radiologists","value":"Radiologists"},{"label":"Rheumatologists","value":"Rheumatologists"},{"label":"General Surgeons","value":"General Surgeons"},{"label":"Urologists","value":"Urologists"},{"label":"Homoeopathy","value":"Homoeopathy"},{"label":"Ayurveda","value":"Ayurveda"},{"label":"Unani","value":"Unani"},{"label":"Dentist","value":"Dentist"},{"label":"Others (Please Specify)","value":"Others (Please Specify)"}];

export const initialState = {
  price: "",
  location: 0,
  speciality: [],
  sortBy: "",
};

const MobileFilters = ({
  open,
  setOpen,
  location,
  setLocation,
  price,
  setPrice,
  sortBy,
  setSortBy,
  speciality,
  setSpeciality,
}) => {
  // console.log("MobileFilters", location, price, sortBy, speciality);
  const [viewmore, setViewMore] = useState(false);
  const [modalFilter, setModalFilter] = useState({
    location,
    sortBy,
    price,
    speciality,
  });

  function handleLocation(e) {
    setModalFilter((prev) => ({ ...prev, location: Number(e.target.value) }));
  }

  function handlePriceFilter(selectedPrice) {
    setModalFilter((prev) => ({ ...prev, price: selectedPrice }));
  }

  function handleSortFilter(selectedSortBy) {
    setModalFilter((prev) => ({ ...prev, sortBy: selectedSortBy }));
  }

  function handleSpecialityFilter(selectedSpeciality) {
    setModalFilter((prev) => {
      if (prev?.speciality?.length > -1) {
        const foundSpecialityIndex = prev.speciality.findIndex(
          (speciality) => speciality === selectedSpeciality
        );
        if (foundSpecialityIndex > -1) {
          const updatedSpeciality = prev.speciality;
          updatedSpeciality.splice(foundSpecialityIndex, 1);
          return { ...prev, speciality: updatedSpeciality };
        } else {
          return {
            ...prev,
            speciality: [...prev.speciality, selectedSpeciality],
          };
        }
      }
    });
  }

  function onClickApply() {
    setLocation(modalFilter.location);
    setPrice(modalFilter.price);
    setSortBy(modalFilter.sortBy);
    setSpeciality(modalFilter.speciality);
    setOpen(false);
  }

  function onClickReset() {
    setLocation(initialState.location);
    setPrice(initialState.price);
    setSortBy(initialState.sortBy);
    setSpeciality(initialState.speciality);
    setModalFilter(initialState);
    setOpen(false);
  }

  useEffect(
    () => {
      // console.log("MobileFilters filter", filter);
      // console.log("MobileFilters modalFilter", modalFilter);
    },
    [
      // filter,
      // modalFilter,
    ]
  );

  useEffect(() => {
    setModalFilter((prevFilter) => ({ ...prevFilter, location }));
  }, [location]);

  useEffect(() => {
    setModalFilter((prevFilter) => ({ ...prevFilter, price }));
  }, [price]);

  useEffect(() => {
    setModalFilter((prevFilter) => ({ ...prevFilter, sortBy }));
  }, [sortBy]);

  useEffect(() => {
    setModalFilter((prevFilter) => ({ ...prevFilter, speciality }));
  }, [speciality]);

  return (
    <Modal
      isOpen={open}
      onRequestClose={() => setOpen(false)}
      style={customStyles}
      overlayClassName="home_filter_overlay"
    >
      <div className="home_filter">
        <div className="home_filter_header">
          <span className="filters_reset_cta" onClick={onClickApply}>
            Apply
          </span>
          <h1>Filters</h1>
          <span className="filters_reset_cta" onClick={onClickReset}>
            Reset
          </span>
        </div>
        
        <div className="home_location_filter">
          <p>
            Location{" "}
          </p>
          <Slider
            value={Number(modalFilter?.location)}
            onChange={handleLocation}
            marks={marks}
            valueLabelDisplay="auto"
          />
        </div>
        {/* PRICE FILTER */}
        <div className="mt-3 d-flex justify-content-start">
          <div className="home_price_filter me-5">
            <p className="mb-2">Consultation Fees</p>
            <form>
              {priceFilters.map((priceFilter, i) => (
                <label
                  key={i}
                  htmlFor={priceFilter.value}
                  className="booking_type_label price_filter_label"
                  onClick={() => handlePriceFilter(priceFilter.value)}
                >
                  {priceFilter.label}
                  <input
                    type="radio"
                    id={priceFilter.value}
                    value={priceFilter.value}
                    name="price"
                    readOnly
                    checked={priceFilter.value === modalFilter?.price}
                  />
                  <span className="booking_type_label_check"></span>
                </label>
              ))}
            </form>
          </div>

          {/* SORT BY FILTER */}
          <div className="home_sort_filter">
            <p className="mb-2">Sort by</p>
            <form>
              {sortFilters.map((sortFilter, i) => (
                <label
                  key={i}
                  htmlFor={sortFilter.value}
                  className="booking_type_label sort_filter_label"
                  onClick={() => handleSortFilter(sortFilter.value)}
                >
                  {sortFilter.label}
                  <input
                    type="radio"
                    id={sortFilter.value}
                    value={sortFilter.value}
                    name="sort"
                    readOnly
                    checked={sortFilter.value === modalFilter?.sortBy}
                  />
                  <span className="booking_type_label_check"></span>
                </label>
              ))}
            </form>
          </div>
        </div>
        {/* SPECIALITY FILTER */}
        <div className="home_speciality_filter">
          <p className="mb-2 mt-2">Speciality</p>
          <form className="home_speciality_filter_list">
            {specialityFilters.map((specialityFilter, i) => {
              if (!viewmore && i > 2) return;
              return (
                <div className="d-flex justify-content-start" key={i}>
                  <input
                    className="checkmark"
                    type="checkbox"
                    id={specialityFilter.value}
                    name={specialityFilter.value}
                    value={specialityFilter.value}
                    onClick={() =>
                      handleSpecialityFilter(specialityFilter.value)
                    }
                    checked={modalFilter?.speciality?.includes(
                      specialityFilter.value
                    )}
                    readOnly
                  />
                  <label htmlFor={specialityFilter.value}>
                    {specialityFilter.label}
                  </label>
                </div>
              );
            })}
          </form>
          <button onClick={() => setViewMore(!viewmore)}>
            {viewmore ? "-View Less" : "+View More"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default MobileFilters;
